
import request from '../request'

export function getDoubtfullClients(params) {
    return request({
        url: '/doubtfull-clients',
        method: "get",
        params,
    })
}

export function getActiveOrderClients(params) {
    return request({
        url: '/order-active-clients',
        method: 'get',
        params,
    })
}
